import web from "@/urls/web";

export default function admin ({ next, store }){
    if(store.getters.userType !== 'Admin'){
        return next({
            name: web.Default.LOGIN_URL.name
        })
    }
    return next()
}